import { reportHomeClick } from "_api/report";

export const TOOL_FUNCTION_CONFIG = [
  // {
  //   name: 'normal',
  //   key: '/',
  //   functions: [
  //     {
  //       name: '组队工具',
  //       key: 'team-center',
  //       route: 'team-center',
  //       img: 'https://imgheybox.max-c.com/oa/2023/08/29/6f6dbcde9d880810a3c62608c8286819.png'
  //     }
  //   ]
  // },
  // {
  //   name: 'pubg',
  //   key: 'pubg',
  //   functions: [
  //     {
  //       name: '绝地求生视频举报',
  //       key: 'video-report',
  //       route: 'pubg-video-report',
  //       img: 'https://imgheybox.max-c.com/oa/2023/08/29/20fe1b0477e7e8e80ffb0b746a38030d.png'
  //     }
  //   ]
  // }
  {
    name: 'mini-program',
    key: 'mini-program',
    functions: [
      {
        name: '最近使用的小程序',
        key: 'recent-mini-program',
        route: 'recent-mini-program',
        img: 'https://imgheybox.max-c.com/oa/2025/05/13/a18220494f96671f21c07a1ab0309ade.png'
      }
    ]
  },
]